import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field, FieldArray } from 'formik'
import axios from 'axios'
import useOnclickOutside from "react-cool-onclickoutside"

import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import { WindowReload, WindowURL, WindowLocation, RouteURL } from '../../../services/redirect'
import Spinner from '../../../services/spinner'
import AlertMessage from '../../../services/alert'

import { DropdownComponent } from '../../../components/options'
import { ValidateForm } from '../../../validations/schemaTerms'


export default function AddComponent(props){

  /*----------------------------------------
    HANDLE CLICK OUTSIDE ELEMENT
  -----------------------------------------*/

  const handleClickAway = useOnclickOutside(() => CallbackModal({close:true}));
  function CallbackModal(data){
    if(spinner){
      return false;
    }
    props.callback(data);
  }


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  /*------------------------------------------------------
    NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }


  /*----------------------------------------
    FORM STATE DATA
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  const [pathUrl, setPathUrl] = useState('');

  const [avatarDefault, setPathUrlDefault] = useState('');
  const [avatarBlank, setPathUrlBlank] = useState('');

  const [state, setstate] = useState({
    message:'',
    status:'1',
  });


  function handleSubmitForm(values, props){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','add');
    formData.append('info',JSON.stringify(values));
    axios.post('/admin/administrations/terms-and-conditions/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);

      if(obj=='success'){
        props.resetForm();
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},2000);
        if(buttonclick==1){
          setTimeout(function() {CallbackModal({close:true,reload:true});},2000);
        }else{
          setTimeout(function() {
            setTimeout(function() {setnotify(false);},2000);
            CallbackModal({reload:true});
          },2000);
        }
        return false;
      }


      if(obj=='error'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},3000);
        return false;
      }

      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Input Error!',text:'Please correct the required fields.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);

      Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

    })
    .catch(function (error){
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
  }

  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/

  const [statusDropdown, setStatusDropdown] = useState([]);
  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setStatusDropdown(source.status);
  }


  useEffect(()=>{
      HandleOptions();
  },[]);


  return (
    <React.Fragment>

    <Formik
        initialValues={state}
        validationSchema={ValidateForm}
        onSubmit={handleSubmitForm}
        render={formProps => {
        const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue } = formProps

        return(
           <Form>
            <div className="modalpanel-wrapper">
              <div className="modalpanel-container small center animate__animated animate__slideInUp animate__faster" ref={handleClickAway}>

              {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
              {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}

              {/*---------------------------------------------------------
                 HEADER
                --------------------------------------------------------*/}
                 <div className="modalpanel-header">
                    <div><h2>Add Terms and Conditions</h2></div>
                    <div onClick={()=>CallbackModal({close:true})}><i className="uil-multiply"></i></div>
                 </div>


                 {/*---------------------------------------------------------
                    BODY
                   --------------------------------------------------------*/}

                 <div className="modalpanel-body">
                    <div className="modalpanel-content">

                        <Form.Group widths="equal">
                            <Field name="message">
                                {({ field, form }) => (
                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Message</label>
                                  <TextArea {...field} onChange={handleChange} rows='9'/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                          </Field>
                        </Form.Group>

                        <Form.Group widths="equal">
                          <Field name="status">
                            {({ field, form }) => (
                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Status</label>
                                  <Select selectOnBlur={false}
                                      {...field}
                                      options={statusDropdown}
                                      onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                            )}
                          </Field>
                        </Form.Group>

                    </div>
                 </div>


                 {/*---------------------------------------------------------
                    FOOTER
                   --------------------------------------------------------*/}

                 <div className="modalpanel-footer">
                    <div className="modalpanel-footer-container">
                       <div>{/*<Button disabled={!(isValid&&dirty)} fluid className='BasicButton strong' content='Save and Exit' icon='save icon'  onClick={() => buttonSubmit(1)}/>*/}</div>
                       <div><Button disabled={!(isValid&&dirty)} fluid className='PrimaryButton strong' content='Save' icon='save icon'  onClick={() => buttonSubmit(1)}/></div>
                     </div>
                     <button type="button" className="display_none" ref={buttonEl} onClick={handleSubmit}></button>
                 </div>



              </div>{/*.modalpanel-container*/}
            </div>
          </Form>
        )}}/>
    </React.Fragment>
  )
}
